// Extract all numbers from a string
export default function sanitizeOrderNumber (str: string) {
    const [l,] = str.split('.')

    const num = l.match(/\d+/g)
    return num ? num.join('') : ''
}